import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import firebase from 'firebase/app'

// import { API_URL } from "@/common/config";

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    Vue.axios.defaults.headers.common[
      "Content-Type"
    ] = "application/json";
  },

  setHeader() {
    return new Promise((resolve, reject) => {
      var user = firebase.auth().currentUser;
      if (user) {
        user.getIdToken().then((accessToken) => {
          Vue.axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${accessToken}`;
          resolve(true)
        }).catch(() => {
          reject(false)
        })

      } else {
        reject(false)
      }
    })

  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  get(resource, slug = "") {
    let slugs = slug ? `/${slug}` : ""
    return Vue.axios.get(`${resource}${slugs}`).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  post(resource, params) {
    return Vue.axios.post(`${resource}`, params);
  },

  update(resource, slug, params) {
    let slugs = slug ? `/${slug}` : ""
    return Vue.axios.put(`${resource}${slugs}`, params);
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

export default ApiService